import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** A titled block of the 사용량 pages: a heading, a short note beside it and
 *  the body. The long explanations are not here — they live in the "설명"
 *  fold of the page or in tooltips. */
export function Section({
  title,
  aside,
  actions,
  children,
  className,
}: {
  title: ReactNode
  /** One short line beside the title. */
  aside?: ReactNode
  actions?: ReactNode
  children: ReactNode
  className?: string
}) {
  return (
    <section aria-label={typeof title === 'string' ? title : undefined} className={cn('min-w-0 space-y-2', className)}>
      <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
        <div className="flex min-w-0 flex-wrap items-baseline gap-x-2">
          <h2 className="text-section font-semibold">{title}</h2>
          {aside && <span className="text-meta text-muted-foreground">{aside}</span>}
        </div>
        {actions}
      </div>
      {children}
    </section>
  )
}

/** A bordered block for a chart or a few tiles. */
export function Panel({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('rounded-lg border border-border bg-card p-4', className)}>{children}</div>
}
